/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Bom_CountInputs */

const vi_packaging_bom_count = /** @type {(inputs: Packaging_Bom_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số vật tư`)
};

/**

* @param {Packaging_Bom_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_bom_count = /** @type {((inputs?: Packaging_Bom_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Bom_CountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_bom_count(inputs)
});